import http from './http';

export default {
  create(user) {
    return http.post('/user', user);
  },
  getAll() {
    return http.get('/campaigns/whatsapp');
  },
  getUserDetails(id) {
    return http.get(`/users/${id}/details`);
  },
};
